module.exports = __webpack_public_path__ + "2b8b8bdeea91ae3489533b4102c2f370.png";